<template>
  <v-card>
    <v-toolbar flat>
      <v-toolbar-title>{{$t('common.divisions.singular')}}</v-toolbar-title>
    </v-toolbar>
    <v-divider/>
    <v-card-text>
      <divisions-drop-down
        :init-division="product.division"
        :multiple="false"
        @select-item="onChangeDivision"
      />
    </v-card-text>
  </v-card>
</template>
<script>
import { isEqual } from 'lodash'
import DivisionsDropDown from "../Common/DivisionsDropDown"

export default {
  components: { DivisionsDropDown },
  props: {
    product: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      model: {}
    }
  },
  methods: {
    onChangeDivision(divisionId){
      this.$emit('change', divisionId)
    }
  }
}
</script>
